import type { ColliderDef, ColliderSceneConfig } from './colliderTypes';

/**
 * Default colliders for the Kaaba scene.
 * Positions are based on the current FBX collision meshes in kaaba.ts.
 * Sizes are rough estimates — fine-tune via dev tools Leva panel.
 */
export const KAABA_DEFAULT_COLLIDERS: ColliderDef[] = [
  {
    id: 'kaaba-cube',
    type: 'box',
    mode: 'solid',
    enabled: true,
    "position": {
      "x": -0.31904604734307435,
      "y": 0.1668963598394823,
      "z": 0.46813923921190986
    },
    "size": {
      "x": 0.26,
      "y": 0.31,
      "z": 0.29
    }
  },
  {
    id: 'scene-boundary',
    type: 'cylinder',
    mode: 'hollow',
    enabled: true,
    blocksLineOfSight: false,
    position: { x: -0.3, y: 0.25, z: 0.5 },
    radius: 1.15,
    height: 0.6,
  },
];

export const DEFAULT_COLLIDER_SCENE_CONFIG: ColliderSceneConfig = {
  cameraRadius: 0.05,
  enabled: true,
  epsilon: 0.0001,
  colliders: KAABA_DEFAULT_COLLIDERS,
};
